module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Bold.b22bc173.ttf";